import parseToHsl from 'polished/lib/color/parseToHsl';
import toColorString from 'polished/lib/color/toColorString';

export function darken(factor: number, color: string): string {
  // S'assurer que le facteur est entre 0 et 1
  const normalizedFactor = Math.max(0, Math.min(1, factor));

  // Convertir la couleur en HSL
  const hsl = parseToHsl(color);

  // Réduire la luminosité proportionnellement
  // Au lieu de simplement soustraire, on multiplie la luminosité par (1 - factor)
  // Cela donne un effet plus naturel et évite l'assombrissement excessif
  hsl.lightness = hsl.lightness * (1 - normalizedFactor);

  // Reconvertir en string de couleur
  return toColorString(hsl);
}
